import { api } from 'redux/api/index.api';
import { getBusinessOrganizationVersion } from 'utils/constants';

export const workspaceMembersApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchWorkspaceMembers: builder.query({
      query: ({ organizationId, workspaceId, searchValue, limit = 100, offset = 0 }) => ({
        url: `${getBusinessOrganizationVersion()}/organizations/${organizationId}/workspaces/${workspaceId}/members?limit=${limit}&offset=${offset}`,
        method: 'POST',
        body: {
          search_term: searchValue,
        },
      }),
      providesTags: ['WorkspaceMembersList'],
      keepUnusedDataFor: 0,
    }),
    addMemberToWorkspace: builder.mutation({
      query: ({ organizationId, workspaceId, userId }) => ({
        url: `${getBusinessOrganizationVersion()}/organizations/${organizationId}/workspaces/${workspaceId}/add-member`,
        method: 'POST',
        body: {
          user_id: userId,
        },
      }),
      invalidatesTags: ['WorkspaceMembersList'],
    }),
    removeMemberFromWorkspace: builder.mutation({
      query: ({ organizationId, workspaceId, userId }) => ({
        url: `${getBusinessOrganizationVersion()}/organizations/${organizationId}/workspaces/${workspaceId}/remove-member`,
        method: 'DELETE',
        body: {
          user_id: userId,
        },
      }),
      invalidatesTags: ['WorkspaceMembersList'],
    }),
  }),
  overrideExisting: 'throw',
});

export const {
  useFetchWorkspaceMembersQuery,
  useLazyFetchWorkspaceMembersQuery,
  useAddMemberToWorkspaceMutation,
  useRemoveMemberFromWorkspaceMutation,
} = api;
